import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { getInitials } from 'signin-app/util/get-initials';
import { useDisplayName } from 'signin-app/helpers/use-display-name';
const CheckOutChildContext = React.createContext(null);
export function CheckOutChildProvider({ children, child }) {
    const displayName = useDisplayName(child === null || child === void 0 ? void 0 : child.name.firstName, child === null || child === void 0 ? void 0 : child.name.lastName);
    const initials = React.useMemo(() => getInitials(displayName), [displayName]);
    return _jsx(CheckOutChildContext, { value: { child, displayName, initials }, children: children });
}
export function useCheckOutChild() {
    const context = React.use(CheckOutChildContext);
    if (context === undefined) {
        throw new Error('useCheckOutChild must be used within a CheckOutChildProvider');
    }
    return context;
}
